// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-micro-right';

export const Component = () => <path d='m15.5 12.402-6 4.597V8z' />;

export const viewBox = '0 0 25 25';
